import type { SurveyElementJson } from '@coorum-research/shared-common/types/survey-json.type'
import { ThemeButton } from './ThemeButton'

type Props = {
  currentPageIndex: number
  allElements: SurveyElementJson[]
  onClickNext: () => void
  onClickBack: () => void
  disabled?: boolean
}

/**
 * SurveyComponentFlow(アンケートページ)のNavigation
 * - NextButtonにはthrottleを設定
 * - PrevButtonにはthrottleを設定しない
 * - disabledが渡されるときには両方のbuttonをdisabledにする
 */
export function SurveyComponentFlowNavigation({
  currentPageIndex,
  allElements,
  onClickNext,
  onClickBack,
  disabled,
}: Props) {
  const isEndPage = currentPageIndex === allElements.length - 1
  const hasPrevPage = currentPageIndex > 0

  return (
    <div className="flex w-full gap-4 p-6">
      {hasPrevPage && (
        <ThemeButton
          variant="outline"
          className="font-semibold"
          onClick={onClickBack}
          disabled={disabled}
        >
          戻る
        </ThemeButton>
      )}
      <ThemeButton
        className="font-semibold"
        onClick={onClickNext}
        throttleMs={isEndPage ? 2000 : 300}
        disabled={disabled}
      >
        {isEndPage ? '完了' : '次へ'}
      </ThemeButton>
    </div>
  )
}
